var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.3335 3.16665H2.66683C2.31321 3.16665 1.97407 3.30713 1.72402 3.55718C1.47397 3.80723 1.3335 4.14637 1.3335 4.49999V13.8333C1.3335 14.1869 1.47397 14.5261 1.72402 14.7761C1.97407 15.0262 2.31321 15.1667 2.66683 15.1667H12.0002C12.3538 15.1667 12.6929 15.0262 12.943 14.7761C13.193 14.5261 13.3335 14.1869 13.3335 13.8333V9.16666M12.3335 2.16665C12.5987 1.90144 12.9584 1.75244 13.3335 1.75244C13.7086 1.75244 14.0683 1.90144 14.3335 2.16665C14.5987 2.43187 14.7477 2.79158 14.7477 3.16665C14.7477 3.54173 14.5987 3.90144 14.3335 4.16665L8.00016 10.5L5.3335 11.1667L6.00016 8.49999L12.3335 2.16665Z",
    stroke: "#5C5858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.5ef83d383f7e936cc1412cebef1bd7a2.svg";
export { ForwardRef as ReactComponent };